import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import CommunicationsList from '../components/communications/CommunicationsList'

export default function CommunicationsPage({ building }) {
  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <CommunicationsList building={building} />
      </Container>
    </main>
  )
}
